import React from "react";
import {s_char_mods_bew, s_char_mods_tot, s_char_mods_wund} from "../_signals/s_char_mods";

export function displaySchwellehModNSC(schwelle: string) {
    let mod = 0;
    switch (schwelle) {
        case 'ts':
            mod = s_char_mods_tot.value;
            break;
        case 'bs':
            mod = s_char_mods_bew.value;
            break;
        case 'ws':
            mod = s_char_mods_wund.value;
    }

    if (mod === 0) return <></>;
    if (mod < 0) return <>{mod}</>;
    return <> +{mod}</>;
}